import { render, staticRenderFns } from "./CouponSelector.vue?vue&type=template&id=2603a5fd&"
import script from "./CouponSelector.vue?vue&type=script&lang=js&"
export * from "./CouponSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports